import React, { useCallback, useEffect, useRef, useState } from 'react'
import Cookies from 'js-cookie'
import { io } from "socket.io-client";
import { useBeforeUnload } from 'react-router-dom';

import AvatarIcon from 'assets/icons/general/AvatarIcon'
import CloseIcon from 'assets/icons/general/CloseIcon'
import SendIcon from 'assets/icons/general/SendIcon'
import MultiChatBubbleIcon from 'assets/icons/general/MultiChatBubbleIcon'
import ExitIcon from 'assets/icons/general/ExitIcon'

// import { useAuth } from 'context/AuthContext'
// import { createChatMessage, endChat, getChatRoom, getUserProfile, initUserChatRoom, updateUserName } from 'api'

const socket = io("http://localhost:4000/");

function SupportChat() {
    const inputRef = useRef(null)
    // const { currentUser, setCurrentUser } = useAuth();
    // const chatRoomId = currentUser?.ChatRooms?.[0]?.id
    const chatRoomId = 1

    const endOfMessageRef = useRef(null)
    const [chatRoom, setChatRoom] = useState([])
    const [newMessage, setNewMessage] = useState("")
    const [loadingReply, setLoadingReply] = useState(false)
    const [isChatOpen, setChatOpen] = useState(false)
    const [isEndChatModalOpen, setEndChatModalOpen] = useState(false)
    const [userName, setUserName] = useState('')
    const [isSubmitting, setSubmitting] = useState(false)

    const handleClose = useCallback(() => {
        setChatOpen(false)
    }, [])

    const scrollToBottom = useCallback(() => {
        setTimeout(() => endOfMessageRef?.current?.scrollIntoView({ behavior: "instant" }), 50)
    }, [])

    const handleOpen = useCallback(async () => {
        if (chatRoomId) {
            setLoadingReply(true)
            // const _chatRoom = await getChatRoom(chatRoomId);
            // setChatRoom(_chatRoom);
            // const data = {
            //     roomId: _chatRoom?.id,
            //     userId: currentUser?.id,
            // }
            // socket.emit("join-room", data)
            setLoadingReply(false)
        } else {
            setLoadingReply(true)
            // const newChatRoom = await initUserChatRoom();
            // const _chatRoom = await getChatRoom(newChatRoom?.id);
            // setChatRoom(_chatRoom);
            // const userProfile = await getUserProfile();
            // setCurrentUser(userProfile)

            // const data = {
            //     roomId: _chatRoom?.id,
            //     userId: userProfile?.id,
            // }
            // socket.emit("join-room", data)
            setLoadingReply(false)
        }
        scrollToBottom()
        setChatOpen(true)
    }, [chatRoomId, scrollToBottom])

    const toggleChat = isChatOpen ? handleClose : handleOpen

    const handleEndChat = async () => {
        // await endChat(chatRoomId)
        Cookies.remove('ut')
        setChatOpen(false)
        setEndChatModalOpen(false)
        window.location.reload();
    }

    const handleChange = (e) => {
        if (e?.target?.name === "new_message") {
            setNewMessage(e?.target?.value)
        }
    }

    const fetchChatRoom = useCallback(async () => {
        // const _chatRoom = await getChatRoom(chatRoomId);
        // setChatRoom(_chatRoom);
        scrollToBottom();
    }, [scrollToBottom])

    const sendMessage = useCallback(async (newMessage) => {
        // await createChatMessage(chatRoomId, currentUser?.id, newMessage)
        // socket.emit("new-message", chatRoomId, currentUser?.role_id, newMessage)
    }, [])

    const handleSubmitMessage = async (e) => {
        e.preventDefault();
        if (newMessage) {
            setSubmitting(true)
            setNewMessage("")
            await sendMessage(newMessage)
            await fetchChatRoom()
            setSubmitting(false)
        }
    }

    const handleClickReplyOption = (option) => {
        setLoadingReply(true)
        sendMessage(option.text)
        fetchChatRoom()
        setLoadingReply(false)
    }

    const handleOnKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSubmitMessage(e)
        }
    }

    const handleSaveName = async () => {
        if (userName.length > 1) {
            setSubmitting(true)
            // await updateUserName(currentUser?.id, userName)
            await sendMessage(userName)
            await fetchChatRoom()
            setSubmitting(false)
            inputRef.current.focus();
        }
    }

    const handleOnInputNameKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSaveName()
        }
    }

    useEffect(() => {
        socket.on("new-message", (chat_room_id, user_role_id, newMessage) => fetchChatRoom())
        return () => socket.off("new-message")
    }, [fetchChatRoom])

    useEffect(() => {
        socket.on("other-new-message", (chat_room_id, user_role_id, newMessage) => fetchChatRoom())
        return () => socket.off("other-new-message")
    }, [fetchChatRoom])

    useEffect(() => {
        socket.on("bot-new-message", (chat_room_id, user_role_id, newMessages) => fetchChatRoom())
        return () => socket.off("bot-new-message")
    }, [fetchChatRoom])

    useBeforeUnload(
        useCallback(() => {
        }, [])
    );

    const disableInput = chatRoom?.ChatMessages?.[chatRoom?.ChatMessages?.length - 1]?.ChatKeyword?.ChatReplyOptions?.find(option => option?.type === "input") || isSubmitting
    const disableSaveName = userName.length < 2 || isSubmitting

    return (
        <div className='chat-widget fixed z-50 bottom-0 right-0 flex flex-col gap-4 items-end justify-end mr-4 mb-4 md:mr-8 md:mb-8 drop-shadow-md'>
            {isChatOpen && (
                <div className="w-72 md:w-80 bg-white drop-shadow-sm rounded-2xl">
                    <div className="h-[500px] md:h-[530px] flex flex-col">
                        <div className="bg-black text-white py-4 px-4 rounded-t-2xl">
                            <div className="flex justify-between mb-2">
                                <p className="font-bold">
                                    Support Chat
                                </p>
                                <div className='flex gap-2 items-center'>
                                    <button className='flex items-center justify-center' onClick={() => setEndChatModalOpen(true)}>
                                        <ExitIcon className="h-4 md:w-4 fill-white" />
                                    </button>
                                    <button className='flex items-center justify-center' onClick={handleClose}>
                                        <CloseIcon className="h-5 md:w-5 fill-white" />
                                    </button>
                                </div>
                            </div>
                            <p className="text-xs">
                                I am your virtual assistant
                            </p>
                        </div>
                        <div className="relative flex-1 px-4 py-3 overflow-y-auto">
                            {chatRoom?.ChatMessages?.map((chat, i) => (
                                chat?.sender_id === 1 ? (
                                    <div key={i} className="flex mb-3 justify-end">
                                        <div className='text-xs bg-app-blue text-white px-3 py-2 mr-2 rounded-l-lg rounded-br-lg h-fit my-auto'>
                                            {chat.text}
                                        </div>
                                        <div>
                                            <div className='rounded-full bg-black w-8 h-8 flex items-center justify-center'>
                                                <AvatarIcon className="fill-white h-4 w-4" />
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div key={i} className="flex mb-3">
                                        <div>
                                            <div className="rounded-full bg-black w-8 h-8 flex items-center justify-center">
                                                <AvatarIcon />
                                            </div>
                                        </div>
                                        <div className="text-xs bg-app-grey text-black px-3 py-2 ml-2 rounded-r-lg rounded-bl-lg h-fit my-auto">
                                            {chat.text}
                                        </div>
                                    </div>
                                )
                            ))}
                            {loadingReply && (
                                <div className="flex mb-3">
                                    <div>
                                        <div className="rounded-full bg-black w-8 h-8 flex items-center justify-center">
                                            <AvatarIcon />
                                        </div>
                                    </div>
                                    <div className="flex gap-1 text-xs bg-app-grey text-black px-3 py-2 ml-2 rounded-r-lg rounded-bl-lg h-fit my-auto">
                                        <span className="relative flex h-2 w-2">
                                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-app-blue opacity-75"></span>
                                            <span className="relative inline-flex rounded-full h-2 w-2 bg-app-blue"></span>
                                        </span>
                                        <span className="relative flex h-2 w-2">
                                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-app-blue opacity-75"></span>
                                            <span className="relative inline-flex rounded-full h-2 w-2 bg-app-blue"></span>
                                        </span>
                                        <span className="relative flex h-2 w-2">
                                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-app-blue opacity-75"></span>
                                            <span className="relative inline-flex rounded-full h-2 w-2 bg-app-blue"></span>
                                        </span>
                                    </div>
                                </div>
                            )}

                            <div className="flex flex-wrap gap-1">
                                {chatRoom?.ChatMessages?.[chatRoom?.ChatMessages?.length - 1]?.ChatKeyword?.ChatReplyOptions?.map((option, i) => (
                                    option.type === "input" ? (
                                        <div className='w-full flex flex-col p-4 bg-app-grey-light-2 rounded-xl shadow-md gap-3'>
                                            <div className='flex flex-col gap-2'>
                                                <label htmlFor={option.text} className='text-xs font-semibold'>{option.text}</label>
                                                <input
                                                    id={option.text}
                                                    className="text-left px-3 py-2 rounded-md border border-app-grey-2 text-xs text-app-blue"
                                                    placeholder={option.text}
                                                    value={userName}
                                                    onChange={(e) => setUserName(e.target.value)}
                                                    onKeyDown={handleOnInputNameKeyDown}
                                                    autoFocus
                                                />
                                            </div>
                                            <button
                                                className={`${disableSaveName ? "bg-app-grey" : "bg-app-blue"} text-white px-3 py-2 text-xs rounded-md hover:opacity-90 transition-all`}
                                                onClick={handleSaveName}
                                                disabled={disableSaveName}
                                            >
                                                Send
                                            </button>
                                        </div>
                                    ) : (
                                        <button
                                            className="text-left px-2 py-1 rounded-3xl border border-app-grey-2 text-xs text-app-blue"
                                            key={i}
                                            onClick={() => handleClickReplyOption(option)}
                                        >
                                            {option.text}
                                        </button>
                                    )
                                ))}
                            </div>
                            <div ref={endOfMessageRef} />
                        </div>

                        <div className="">
                            <form className="flex mb-3">
                                <input
                                    ref={inputRef}
                                    className="text-xs py-2 px-4 flex-1 focus:outline-none"
                                    placeholder="Write your message here"
                                    name="new_message"
                                    value={newMessage}
                                    onChange={handleChange}
                                    autoComplete="off"
                                    autoFocus
                                    onKeyDown={handleOnKeyDown}
                                    disabled={disableInput}
                                />
                                <button
                                    className="bg-white py-2 px-4"
                                    onClick={handleSubmitMessage}
                                    disabled={disableInput}
                                >
                                    <SendIcon />
                                </button>
                            </form>
                        </div>
                    </div>

                    {isEndChatModalOpen && (
                        <div className='fixed top-0 bg-white mt-12 right-0 left-0 mx-4 rounded-md p-4 text-xs flex flex-col items-center gap-2 drop-shadow-md'>
                            <p className='font-bold'>End Chat?</p>
                            <p>All your message will be lost</p>
                            <div className='flex gap-2 w-full'>
                                <button className='border border-black flex-1 text-center py-1' onClick={() => setEndChatModalOpen(false)}>No</button>
                                <button className='bg-black text-white flex-1 text-center py-1' onClick={handleEndChat}>Yes</button>
                            </div>
                        </div>
                    )}
                </div>
            )}
            <button
                className='bg-app-cream h-10 w-10 md:h-14 md:w-14 flex items-center justify-center rounded-full drop-shadow-md transition-all md:hover:-translate-y-1'
                onClick={toggleChat}
            >
                {isChatOpen ? (
                    <CloseIcon className="h-6 w-6 md:h-8 md:w-8 fill-app-blue" />
                ) : (
                    <MultiChatBubbleIcon className="h-6 w-6 md:h-8 md:w-8 fill-app-blue" />
                )}
            </button>
        </div>
    )
}

export default SupportChat;